import { FC, memo, useState } from 'react'

import { HistoryTable } from 'bank-entity-history'
import { Accordion, DateTime, IconName, Info, Layer, TextMask } from 'ui/components'
import { Col, Row } from 'ui/themes/globalStyles'

import * as SC from '../../styles'
import { BioTrackCollectionData, ConnectionsDetailsFormPayload, ConnectionsDetailsWebPage } from '../../types'
import { ConnectionsTable } from '../ConnectionsTable'

type Props = {
  collection: BioTrackCollectionData
  payload: ConnectionsDetailsFormPayload
  setPayload: (payload: ConnectionsDetailsFormPayload) => void
  getWebPage: (payload: ConnectionsDetailsFormPayload) => Promise<ConnectionsDetailsWebPage>
}

export const BioTrackCollection: FC<Props> = memo((props) => {
  const { collection, payload, getWebPage, setPayload } = props
  const [isLoading, setIsLoading] = useState(false)
  return (
    <SC.Section>
      <Layer shadowed rounded>
        <SC.TableHeader>
          <SC.TableInfo>
            <Row>
              <Col>
                <Info label="Email">{collection.email}</Info>
              </Col>
              <Col>
                <Info label="Password">
                  <TextMask fullyHidden text={collection.password} />
                </Info>
              </Col>
            </Row>
            <Row>
              <Col>
                <Info label="UBI">{collection.ubi}</Info>
              </Col>
            </Row>
          </SC.TableInfo>
          <SC.TableKeyInfo>
            <SC.KeyAddedInfoIcon name={IconName.INFO_ROUND} /> Key was added{' '}
            <DateTime date={collection.keyAddedDate} withTime />
          </SC.TableKeyInfo>
        </SC.TableHeader>
        <ConnectionsTable connections={collection.connections} />
      </Layer>

      <Layer shadowed rounded>
        <Accordion title="View history" expanded={false} isGrey>
          <HistoryTable
            loading={isLoading}
            // eslint-disable-next-line
            // @ts-ignore
            dataQa={`history_${collection.id}`}
            items={collection.history}
            pagination={{
              total: collection.historyTotalCount,
              page: payload.bioTrackHistoryPages[collection.id],
              size: payload.bioTrackHistorySizes[collection.id],
              tooMany: collection.historyTotalCount === 10001,
              onChange: async (page: number, size: number) => {
                const newPayload = { ...payload }
                newPayload.bioTrackHistoryPages[collection.id] = page
                newPayload.bioTrackHistorySizes[collection.id] = size
                setPayload(newPayload)
                setIsLoading(true)
                await getWebPage(newPayload)
                setIsLoading(false)
              }
            }}
          />
        </Accordion>
      </Layer>
    </SC.Section>
  )
})
